import styled from 'styled-components'
import { Collapse } from 'antd'

export const MyCollapse = styled(Collapse)`
  .ant-collapse-item {
    border-top: 1px solid ${props => props.theme.light1};
    .ant-collapse-header {
      padding: 32px 0 40px 0;
      color: ${props => props.theme.dark2};
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
    }
    .ant-collapse-content {
      color: ${props => props.theme.divider2};
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 36px;
      .ant-collapse-content-box {
        padding: 0;
      }
    }
  }
`
